module.exports = __webpack_public_path__ + "img/sec-d.f43849a1.svg";